// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__2BL5P","control":"Checkout_control__1oIgG","actions":"Checkout_actions__130eF","submit":"Checkout_submit__3eyIX","invalid":"Checkout_invalid__3PgJF"};